import { useLocation, matchPath } from "react-router-dom";
import SidebarMenuItem from "./item";
//import menuItems, { MenuItem } from "./items";
import { useContext, useState } from "react";
import { mergeMenuItems } from "./helpers";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import { SubMenuWrapper } from "./components/SubMenuStyles";

export interface MenuItem {
  link?: string;
  icon?: any;
  badge?: string;
  children?: any[];
  name: string;
}

const renderSidebarMenuItems = ({
  items,
  path,
  openMenu,
  setOpenMenu,
}: {
  items: any;
  path: string;
  openMenu: string[];
  setOpenMenu: Function;
}): JSX.Element => (
  <SubMenuWrapper key={items.path}>
    {items?.reduce(
      (ev: any, item: any) =>
        reduceChildRoutes({ ev, item, path, openMenu, setOpenMenu }),
      []
    )}
  </SubMenuWrapper>
);

const reduceChildRoutes = ({
  ev,
  path,
  item,
  openMenu,
  setOpenMenu,
}: {
  ev: JSX.Element[];
  path: string;
  item: MenuItem;
  openMenu: string[];
  setOpenMenu: Function;
}): Array<JSX.Element> => {
  if (item.name) {
    const key = item.name;
    const exactMatch = item.link
      ? !!matchPath({ path: item.link, end: false }, path)
      : false;

    if (item.children) {
      const partialMatch = item.link
        ? !!matchPath({ path: item.link, end: false }, path)
        : false;

      ev.push(
        <SidebarMenuItem
          key={key}
          active={partialMatch}
          open={partialMatch}
          name={item.name}
          icon={item.icon}
          link={item.link}
          badge={item.badge}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          menus={item}
        >
          {renderSidebarMenuItems({
            path,
            items: item.children,
            openMenu,
            setOpenMenu,
          })}
        </SidebarMenuItem>
      );
    } else {
      ev.push(
        <SidebarMenuItem
          key={key}
          active={exactMatch}
          name={item.name}
          link={item.link}
          badge={item.badge}
          icon={item.icon}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          menus={item}
        />
      );
    }
  }
  return ev;
};

function SidebarMenu() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<any>([]);
  const { routes } = useContext(SidebarContext);
  const sideMenuItems = mergeMenuItems(routes, true);

  return (
    <>
      {sideMenuItems.map((menuItem: any, index: any) => (
        <span key={index}>
          {renderSidebarMenuItems({
            items: menuItem.items,
            path: location.pathname,
            openMenu,
            setOpenMenu,
          })}
        </span>
      ))}
    </>
  );
}

export default SidebarMenu;

